import * as Yup from "yup";
import {
  WEBSITE_LINK_VALIDATION_SCHEMA,
  FIRST_NAME_VALIDATION_SCHEMA,
  MAX_LENGTH_VALIDATION,
  LAST_NAME_VALIDATION_SCHEMA,
  PHONE_VALIDATION_SCHEMA,
  PASSWORD_VALIDATION_SCHEMA,
  NOT_EMPTY_ARRAY_VALIDATION,
} from "src/constants/formValidation";
import { RegistrationFields } from "src/page-components/auth/RegistrationForm/types";

export const SETTINGS_VALIDATION_SCHEMA_FOR_AGENT = Yup.object().shape({
  [RegistrationFields.country]: Yup.string().required("required"),
  [RegistrationFields.companyName]: Yup.string().required("required"),
  [RegistrationFields.companyAddress]: Yup.string().required("required"),
  [RegistrationFields.website]:
    WEBSITE_LINK_VALIDATION_SCHEMA.required("required"),
  [RegistrationFields.firstName]: FIRST_NAME_VALIDATION_SCHEMA,
  [RegistrationFields.description]: MAX_LENGTH_VALIDATION(2000),
  [RegistrationFields.lastName]: LAST_NAME_VALIDATION_SCHEMA,
  [RegistrationFields.phoneNumber]: PHONE_VALIDATION_SCHEMA,
  [RegistrationFields.password]: PASSWORD_VALIDATION_SCHEMA.optional(),
});

export const SETTINGS_VALIDATION_SCHEMA_OWNER = Yup.object().shape({
  ...SETTINGS_VALIDATION_SCHEMA_FOR_AGENT.fields,
  [RegistrationFields.industry]: Yup.string().required("required"),
  [RegistrationFields.international]: Yup.boolean().required("required"),
  [RegistrationFields.reprecentionCountries]: NOT_EMPTY_ARRAY_VALIDATION,
});
